import script from "./FlipCharts.vue?vue&type=script&setup=true&lang=js"
export * from "./FlipCharts.vue?vue&type=script&setup=true&lang=js"

import "./FlipCharts.vue?vue&type=style&index=0&id=460c0f59&lang=scss"

const __exports__ = script;

export default __exports__